import PartnerService from '../services/Partner.service';
import { observable } from 'mobx';

class PartnersStore {
  partners = observable([]);
  initialFetchDone = observable.box(false);

  async fetchPartners() {
    if (this.isLoaded()) {
      return this.partners;
    }

    try {
      const items = await PartnerService.fetchPartners();

      if (items.isEmpty) {
        return null;
      }

      this.partners.push(...items.items);
      this.initialFetchDone.set(true);
      return this.partners;
    } catch (e) {
      this.initialFetchDone.set(false);
      console.error('Failed to fetch partners data');
      return null;
    }
  }

  isLoaded() {
    return this.initialFetchDone.get();
  }
}

export default new PartnersStore();



// WEBPACK FOOTER //
// ./src/stores/Partners.store.js